import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { fakeAction } from 'redux/slices/transaction';

import ModalWithChildren from 'components/ModalWithChildren';

import { sendReceipt as TEXT } from 'locales/en/transaction';

const SendReceipt = ({ transaction, className }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const email = useSelector((state) => state.auth.user.email);

  const onClickConfirm = () => {
    setIsLoading(true);
    dispatch(fakeAction()).then(() => {
      setIsOpen(false);
      setIsLoading(false);
    });
  };

  return (
    <>
      <button className={className} onClick={() => setIsOpen(true)}>
        {TEXT.sendReceipt}
      </button>
      {isOpen && (
        <ModalWithChildren
          isOpen
          header={TEXT.sendReceipt}
          isLoading={isLoading}
          ctaTitle={isLoading ? `${TEXT.send}ing` : TEXT.send}
          onClickCta={handleSubmit(onClickConfirm)}
          cta2Title={TEXT.cancel}
          onClickCta2={() => setIsOpen(false)}
        >
          <>
            <div className="relative flex flex-row items-center justify-between mt-12">
              <span className="text-xs text-javelin-gray-light">
                {TEXT.deliveryTo}
              </span>
              <input
                className={`input input-full-border py-3 px-4 border-javelin-gray-border border w-4/6`}
                disabled
                placeholder="Enter your email address"
                value={email}
                {...register('email')}
              />
            </div>
          </>
        </ModalWithChildren>
      )}
    </>
  );
};

SendReceipt.propTypes = {
  transaction: PropTypes.shape({}),
  className: PropTypes.string,
};
SendReceipt.defaultProps = {
  className: 'btn btn-secondary w-40 h-11 px-0',
};

export default SendReceipt;
